<template>
  <div>
    <div class="footer">
      <div class="wrap pc">
        <div v-for="(item, index) in arr" :key="index">
          <img :src="item.icon" alt=""/>
          <p>
            {{ item.name }}
            <br/>
            {{ item.desc }}
          </p>
        </div>
      </div>
      <div class="mobile-wrap mobile">
        <div class="left">
          <div v-for="(item, index) in arr.slice(0, arr.length - 1)" :key="index">
            <img :src="item.icon" alt=""/>
            <span>{{ item.name }}{{ item.desc }}</span>
          </div>
        </div>
        <div class="right">
          <img :src="arr[4].icon" alt=""/>
          <div>
            <p>{{ arr[4].name }}</p>
            <p>{{ arr[4].desc }}</p>
          </div>
        </div>
      </div>
    </div>
    <p class="beian" style="">
      <a
          href="http://beian.miit.gov.cn" target="_blank"><span>©2022 xinli121.com 版权所有 </span>&nbsp;&nbsp;&nbsp;&nbsp;蜀ICP备2021002638号-1</a>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      arr: [
        {
          icon: require("../assets/imgs/call.png"),
          name: "24小时",
          desc: "响应",
        },
        {
          icon: require("../assets/imgs/seriver.png"),
          name: "优质配套",
          desc: "服务",
        },
        {
          icon: require("../assets/imgs/guarantee.png"),
          name: "无忧",
          desc: "运维保障",
        },
        {
          icon: require("../assets/imgs/client.png"),
          name: "多端",
          desc: "服务支持",
        },
        {
          icon: require("../assets/imgs/v-code.png"),
          name: "扫一扫",
          desc: "立即咨询",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  background-color: #3a3334;

  .wrap {
    display: flex;
    height: 190px;
    justify-content: space-between;
    align-items: center;

    & > div {
      display: flex;
      align-items: center;
      font-size: 16px;
      height: 80px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #f6f6f6;
      line-height: 30px;
      padding-right: 32px;
      margin-right: 81px;
      border-right: 1px solid #d6d6d6;
      box-sizing: border-box;

      img {
        width: 47px;
        margin-right: 25px;
      }

      &:first-child {
        padding-left: 0;
        padding-right: 44px;
      }

      &:last-child {
        padding-right: 0;
        border-right: unset;
        margin-right: 0;
      }
    }
  }
}

@media (max-width: 760px) {
  .footer {
    height: unset;
    padding: 0.4rem 0;

    .mobile-wrap {
      display: flex;

      .left {
        width: calc(100% - 2.79rem);
        display: flex;
        justify-content: space-between;
        font-size: 0.18rem;
        color: white;
        padding: 0 0.35rem;
        padding-right: 0.7rem;
        border-right: 1px solid white;
        flex-wrap: wrap;

        img {
          width: 0.23rem;
          margin-right: 0.13rem;
          vertical-align: middle;
        }
      }

      .right {
        display: flex;
        padding-left: 0.64rem;
        width: 2.79rem;

        img {
          width: 0.65rem;
        }

        div {
          width: calc(100% - 0.65rem);
          color: white;
          font-size: 0.2rem;
        }
      }
    }
  }
}

.beian {
  text-align: center;
  background: #3a3334;
  line-height: 20px;
  font-size: 0;
  margin: 0;

  a {
    color: #FFFFFF;
    font-size: 16px;
    text-decoration: none;
    span{
      padding-right: 10px ;
      text-decoration: none;
    }
  }
}
</style>
